/**
 * @param {string} name 子应用名称，会被拼入 dom id 属性中，应唯一
 * @param {string} entry 可访问到子应用的 url
 * @param {string | string[]} activeRule 不应有冲突，且具备唯一性
 */

export default [
  {
    name: '门店选址',
    entry: '/pe-npds-fe-house/index.html',
    activeRule: '/house'
  },
  {
    name: 'LOCA 配置管理',
    entry: '/pe-powerpro-fe-loca/index.html',
    activeRule: '/loca'
  },
  {
    name: '字典管理',
    entry: '/pe-powerpro-fe-mozi/index.html',
    activeRule: '/mozi'
  },
  {
    name: '工单管理',
    entry: '/pe-powerpro-fe-nvwa/index.html',
    activeRule: '/nvwa'
  },
  {
    name: '工单',
    entry: '/pe-powerpro-fe-bohu/index.html',
    activeRule: '/bohu'
  },
  {
    name: '工单',
    entry: '/pe-pg-fe-workflow/index.html',
    activeRule: '/workflow'
  }
]
